import { apiRootUrl } from '../config.local';
import { ReferenceDetails } from '../models/be/Reference';

export default async function getReferenceDetails(email: string, token: string): Promise<ReferenceDetails> {
	const headers = {
		'Content-Type': 'application/json'
	};
	const response = await fetch(`${apiRootUrl}/api/referee/login?email=${encodeURIComponent(email)}&token=${token}`, {
		method: 'GET',
		headers
	});

	if (!response.ok) {
		throw new Error(`Request failed with status: ${response.status}`);
	}
	const data = await response.json();
	return data;
}
